import LegalLayout, { LegalSection, LegalList } from "../../components/chalk/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" eyebrow="Legal" lastUpdated="February 2026" testId="page-privacy">
      <LegalSection heading="What we collect">
        <p>
          Chalk OS collects account, team, roster, guardian, athlete, event, RSVP, message, file,
          notification, device, subscription, and support data — the information you and your team
          provide in the course of using the platform, plus standard service logs we need to operate
          and secure it.
        </p>
      </LegalSection>

      <LegalSection heading="How we use data">
        <LegalList items={[
          "Operate the platform and deliver the features you sign up for.",
          "Send team communications you and your coaches initiate.",
          "Manage subscriptions and billing.",
          "Secure accounts and prevent abuse.",
          "Provide customer support.",
          "Improve the product through aggregated, non-identifying analysis.",
          "Comply with law and respond to lawful requests.",
        ]} />
      </LegalSection>

      <LegalSection heading="What we do not do">
        <LegalList items={[
          "Chalk OS does not sell personal information.",
          "Chalk OS does not use athlete data for targeted advertising.",
          "Chalk OS does not knowingly allow children under 13 to create independent accounts in V1.",
        ]} />
      </LegalSection>

      <LegalSection heading="Who sees what">
        <p>
          Within a team, coaches and league admins see the information needed to run the season:
          schedules, roster, RSVPs, and chalk-talk messages. Guardian email and medical notes are
          restricted and are never shown to other parents in the app. Emergency contact data is
          restricted to the coach and league admin for the athlete's team.
        </p>
      </LegalSection>

      <LegalSection heading="Your rights">
        <p>
          Guardians may request access to, correction of, or deletion of personal information by
          emailing <a href="mailto:support@getchalkos.com" style={{ color: "#2E7D52" }}>support@getchalkos.com</a> from the
          address on the account. We may need to verify identity before processing the request.
        </p>
      </LegalSection>

      <LegalSection heading="Data retention">
        <p>
          We delete or anonymize personal data when it is no longer needed for the purposes above.
          Chalk OS may retain limited records for security, billing, audit, dispute prevention, and
          legal compliance.
        </p>
      </LegalSection>

      <LegalSection heading="Children's data">
        <p>
          See our <a href="/children-privacy" style={{ color: "#2E7D52" }}>Children's Privacy</a> page for the
          specific protections that apply to athlete profiles and minor data.
        </p>
      </LegalSection>

      <LegalSection heading="Service providers">
        <p>
          We use vetted vendors to host the platform, deliver email, process payments, and run other
          standard operations. These vendors only receive the data they need to perform their service
          and are contractually limited from using it for any other purpose.
        </p>
      </LegalSection>

      <LegalSection heading="Changes to this policy">
        <p>
          We may update this policy from time to time. Material changes will be reflected in the
          "Last updated" date and communicated through the app or email.
        </p>
      </LegalSection>

      <LegalSection heading="Contact">
        <p>
          Privacy questions and rights requests:{" "}
          <a href="mailto:support@getchalkos.com" style={{ color: "#2E7D52" }}>support@getchalkos.com</a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
